import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["halfmodal", "sortOption", "currentSort"];

  close() {
    if (!this.halfmodalTarget.classList.contains("is-open")) return;
    this.halfmodalTarget.classList.remove("is-open");
  }

  select(event) {
    const sortOrder = event.currentTarget.dataset.sortOrder;

    // 絞り込み処理
    const form = document.getElementById("search_form");
    const sortField = form.querySelector('input[name="q[s]"]');

    if (sortField) {
      sortField.value = sortOrder;
    } else {
      console.error("Sort field not found in the form");
    }

    // is-selected クラスの更新
    this.sortOptionTargets.forEach((element) => {
      element.classList.remove("is-selected");
    });
    event.currentTarget.parentElement.classList.add("is-selected");

    form.requestSubmit();

    // 現在の並び順を表示
    this.currentSortTarget.textContent = event.currentTarget.textContent;

    // モーダルを閉じる
    this.close();
  }
}
